import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import RemoveOutlinedIcon from "@mui/icons-material/RemoveOutlined";
import ViewInArOutlinedIcon from "@mui/icons-material/ViewInArOutlined";
import WebIcon from "@mui/icons-material/Web";
import WebhookOutlinedIcon from "@mui/icons-material/WebhookOutlined";

import { routes } from "Constant/routes";
import { SidebarItems } from "Constant/sidebar";
import Swal from "sweetalert2";

import { startSubscriptionAsync } from "helpers/business/getBusiness";

import SwalAlertComp from "components/SwalAlert";

export const createSidebarItems = ({
    language,
    landingPageService,
    sidebarOpenedItem,
    signalService,
    leadService,
    dispatchSetSidebarItem,
    setIsLeadModalOpen,
    setIsLandingPageModalOpen,
}) => {
    const openBusinessHandle = () => {
        const val =
            sidebarOpenedItem === SidebarItems.BUSINESS
                ? null
                : SidebarItems.BUSINESS;
        dispatchSetSidebarItem(val);
    };
    const openLeadHandle = () => {
        if (!leadService) {
            setIsLeadModalOpen(true);
        } else {
            const val =
                sidebarOpenedItem === SidebarItems.LEADS
                    ? null
                    : SidebarItems.LEADS;
            dispatchSetSidebarItem(val);
        }
    };

    const startSignalSubscription = async () => {
        let data = {
            package_code: "SIGNAL-B",
        };
        let response = await startSubscriptionAsync(data);
        if (response.status) {
            window.location.reload();
        } else {
            SwalAlertComp({
                title: language?.delete_swal_modal?.failed ?? "Failed",
                message: response.message && response.message,
                icon: "error",
            });
        }
    };

    const openSignalHandle = () => {
        if (!signalService) {
            Swal.fire({
                title:
                    language?.delete_swal_modal
                        ?.you_signal_service_subscription ??
                    "You can start your Signal Service subscription",
                icon: "info",
                showClass: {
                    popup: "animate__animated animate__fadeInDown",
                },
                hideClass: {
                    popup: "animate__animated animate__fadeOutUp",
                },
                showCancelButton: true,
                focusConfirm: false,
                confirmButtonText: "Start Now!",
            }).then(
                (sweetAlertResult) =>
                    sweetAlertResult.value && startSignalSubscription(),
            );
        } else {
            const val =
                sidebarOpenedItem === SidebarItems.SIGNAL
                    ? null
                    : SidebarItems.SIGNAL;
            dispatchSetSidebarItem(val);
        }
    };

    const openLandingPageHandle = () => {
        if (!landingPageService) {
            setIsLandingPageModalOpen(true);
        } else {
            const val =
                sidebarOpenedItem === SidebarItems.LANDING_PAGE
                    ? null
                    : SidebarItems.LANDING_PAGE;
            dispatchSetSidebarItem(val);
        }
    };

    return [
        {
            title: "DASHBOARD",
            testId: "sidebar-dashboard",
            icon: <DashboardOutlinedIcon />,
            route: routes.home,
        },
        {
            title: "BUSINESS",
            testId: "sidebar-business",
            onClick: openBusinessHandle,
            icon: <ManageAccountsOutlinedIcon />,
            itemKey: SidebarItems.BUSINESS,
            children: [
                {
                    title: language?.sidebar?.subscriptions ?? "Subscriptions",
                    testId: "sidebar-business-subscriptions",
                    route: `${process.env.REACT_APP_CONSOLE_URL}/dash/subscriptions`,
                    icon: <RemoveOutlinedIcon />,
                    isExternalRoute: true,
                    /**
                     * @description isExternalRoute renders "a" tag.
                     */
                },
                {
                    title: language?.sidebar?.teammates ?? "Teammates",
                    testId: "sidebar-business-teammates",
                    route: `${process.env.REACT_APP_CONSOLE_URL}/dash/businesses/users`,
                    icon: <RemoveOutlinedIcon />,
                    isExternalRoute: true,
                },
                {
                    title: language?.sidebar?.invoices ?? "Invoices",
                    testId: "sidebar-business-invoices",
                    route: `${process.env.REACT_APP_CONSOLE_URL}/dash/invoices`,
                    icon: <RemoveOutlinedIcon />,
                    isExternalRoute: true,
                },
                {
                    title:
                        language?.sidebar?.payment_methods ?? "Payment Methods",
                    testId: "sidebar-business-payment-methods",
                    route: `${process.env.REACT_APP_CONSOLE_URL}/dash/payment-methods`,
                    icon: <RemoveOutlinedIcon />,
                    isExternalRoute: true,
                },
            ],
        },
        {
            title: "SIGNAL",
            testId: "sidebar-signal",
            icon: <WebhookOutlinedIcon />,
            onClick: openSignalHandle,
            itemKey: SidebarItems.SIGNAL,

            children: [
                {
                    title: language?.sidebar?.trackers ?? "Trackers",
                    testId: "sidebar-trackers",
                    route: routes.trackers,
                    icon: <RemoveOutlinedIcon />,
                },
                {
                    title: language?.sidebar?.sources ?? "Sources",
                    testId: "sidebar-sources",
                    route: routes.sources,
                    icon: <RemoveOutlinedIcon />,
                },
                {
                    title: language?.sidebar?.destinations ?? "Destinations",
                    testId: "sidebar-destinations",
                    route: routes.destinations,
                    icon: <RemoveOutlinedIcon />,
                },
                {
                    title: language?.sidebar?.trackerEvents ?? "Event Mappings",
                    testId: "sidebar-event-mappings",
                    route: routes.tracker_events,
                    icon: <RemoveOutlinedIcon />,
                },
            ],
        },
        {
            title: "LEADS",
            testId: "sidebar-leads",
            icon: <ViewInArOutlinedIcon />,
            onClick: openLeadHandle,
            itemKey: SidebarItems.LEADS,
            children: [
                {
                    title: language?.lead?.connections ?? "Connections",
                    testId: "sidebar-lead-connections",
                    route: routes.connection,
                    icon: <RemoveOutlinedIcon />,
                },
                {
                    title: language?.lead?.sources ?? "Sources",
                    testId: "sidebar-lead-sources",
                    route: routes.leadSources,
                    icon: <RemoveOutlinedIcon />,
                },
                {
                    title: language?.sidebar?.destinations ?? "Destinations",
                    testId: "sidebar-lead-destinations",
                    route: routes.leadDestinations,
                    icon: <RemoveOutlinedIcon />,
                },
                {
                    title: language?.sidebar?.services ?? "Services",
                    testId: "sidebar-lead-services",
                    route: routes.service,
                    icon: <RemoveOutlinedIcon />,
                },
                {
                    title:
                        language?.lead?.general_reports ??
                        "Leads General Reports",
                    testId: "sidebar-lead-general-reports",
                    route: routes.leadGeneralReports,
                    icon: <RemoveOutlinedIcon />,
                },
            ],
        },
        {
            title: "LANDING PAGE",
            testId: "sidebar-landing-page",
            icon: <WebIcon />,
            onClick: openLandingPageHandle,
            itemKey: SidebarItems.LANDING_PAGE,
            children: [
                {
                    title: "Landing Pages",
                    testId: "sidebar-landing-pages",
                    route: routes.landing_pages,
                    icon: <RemoveOutlinedIcon />,
                },
                {
                    title: "Reports",
                    testId: "sidebar-landing-page-reports",
                    route: routes.landing_page_reports,
                    icon: <RemoveOutlinedIcon />,
                },
            ],
        },
    ];
};

export const handleLocationChange = ({
    location,
    setActiveItem,
    dispatchClearSidebarItem,
    dispatchSetSidebarItem,
}) => {
    // Dynamic path: edit URL contains an ID (e.g. /tracker-events/edit/123)
    if (location.pathname.startsWith(routes.tracker_events_edit + "/")) {
        setActiveItem(routes.tracker_events);
        dispatchSetSidebarItem(SidebarItems.SIGNAL);
        return;
    }

    switch (location.pathname) {
        case routes.home:
            setActiveItem(routes.home);
            dispatchClearSidebarItem();
            break;
        case routes.trackers:
            setActiveItem(routes.trackers);
            dispatchSetSidebarItem(SidebarItems.SIGNAL);
            break;
        case routes.sources:
            setActiveItem(routes.sources);
            dispatchSetSidebarItem(SidebarItems.SIGNAL);
            break;
        case routes.destinations:
            setActiveItem(routes.destinations);
            dispatchSetSidebarItem(SidebarItems.SIGNAL);
            break;
        case routes.wizard:
            setActiveItem(routes.wizard);
            dispatchSetSidebarItem(SidebarItems.SIGNAL);
            break;
        case routes.landing_pages:
            setActiveItem(routes.landing_pages);
            dispatchSetSidebarItem(SidebarItems.LANDING_PAGE);
            break;
        case routes.landing_page_reports:
            setActiveItem(routes.landing_page_reports);
            dispatchSetSidebarItem(SidebarItems.LANDING_PAGE);
            break;
        case routes.tracker_events:
        case routes.tracker_events_create:
            setActiveItem(routes.tracker_events);
            dispatchSetSidebarItem(SidebarItems.SIGNAL);
            break;

        case routes.connection:
            setActiveItem(routes.connection);
            dispatchSetSidebarItem(SidebarItems.LEADS);
            break;
        case routes.leadGeneralReports:
            setActiveItem(routes.leadGeneralReports);
            dispatchSetSidebarItem(SidebarItems.LEADS);
            break;
        case routes.leadSources:
            setActiveItem(routes.leadSources);
            dispatchSetSidebarItem(SidebarItems.LEADS);
            break;
        case routes.leadDestinations:
            setActiveItem(routes.leadDestinations);
            dispatchSetSidebarItem(SidebarItems.LEADS);
            break;
        case routes.service:
            setActiveItem(routes.service);
            dispatchSetSidebarItem(SidebarItems.LEADS);
            break;
        default:
            break;
    }
};
